<template>
 <div class="backedCom">
   <h5 class="f24">换背日期：{{item.createTime}}</h5>
   <section>
	 <div class="pro"  @click="$router.push({name:'proDetail',query:{id:item.orderItem.productSku}})">
	   <div class="pic l">
		 <img align="middle" :src="item.orderItem.productPic  | formatImgUrl(250,250,true)">
	   </div>
	   <div class="inner r">
		 <h2 class="f24 bold twoClamp">{{item.orderItem.productName}}</h2>
		 <h3 class="grey6 f26"><span>{{item.orderItem.productBrand}}</span><i>|</i><span>{{item.orderItem.colorName}}</span></h3>
	   </div>
	 </div>
	 <div class="botWrap f22">
	   <p><span>总计支付：</span><span class="f26 bold">¥{{item.payAmount}}</span></p>
	   <p><span>订单编号：</span><span class="f26 bold">{{item.orderCode}}</span></p>
	 </div>
   </section>
   
 </div>
</template>

<script>
  export default {
    name: "backed",
	props:{
      item:{
        type:Object,
		default:()=>{}
	  }
	},
    data() {
      return {}
    },
    watch: {},
    computed: {},
    created() {
    },
    mounted() {
    },
    methods: {}

  }
</script>

<style lang="scss" scoped>
  .backedCom{
	margin-bottom: 84px;
	h5{
	  line-height: 34px;
	  margin-bottom: 32px;
	  padding-left: 48px;
	  background: url("/images/order/clock_icon.png") no-repeat 6px center;
	  background-size: 32px;
	}
	section{
	  height:342px;
	  border-radius:$base-radius;
	  border:1px solid #e9e9e9;
	  overflow: hidden;
	}
	.pro{
	  height:196px;
	  padding: 2px;
	  background: $white-color;
	  border-bottom:1px solid #E9E9E9;
	  .pic{
		width: 140px;
		height: 140px;
		padding: 28px 34px;
		background: $white-color;
		img{
		  width: 140px;
		  height: 140px;
		}
	  }
	  .inner{
		width: 450px;
		height: 196px;
		background: #f8f8f8;
		padding: 40px 32px 0 24px;
		box-sizing: border-box;
		position: relative;
		h2{
		  line-height: 34px;
		  margin-bottom: 16px;
		}
		h3{
		  line-height: 36px;
		  i{
			margin: 0 28px;
			color: $primary-color;
		  }
		}
	  }
	}
	.botWrap{
	  padding: 32px 40px 0;
	  p{
		line-height: 32px;
		margin-bottom: 18px;
		display: flex;
		justify-content: space-between;
	  }
	  
	}
  }
</style>
